'use client';

import { useState } from 'react';
import { useUnit } from 'effector-react';
import classNames from 'classnames';
import { $ModalStore } from '@nx-frontend/shared/ui/modal';
import { WizardExitPopupPayload, PopupType } from '@nx-frontend/shared/types';

export function WizardExitPopup() {
  const [store] = useUnit([$ModalStore]);

  // Найдем модальное окно с нужным типом PopupType.WIZARD_EXIT
  const modal = store.find((modal) => modal.payload && modal.payload.payloadType === PopupType.WIZARD_EXIT);
  const payload = modal?.payload as WizardExitPopupPayload;

  const options = [
    'The setup process takes too long',
    "The product doesn't look interesting",
    "I don't understand what I'm supposed to do",
    'I expected the product to work differently',
    'Technical issues/unable to complete a step',
    'Other (please specify)',
  ];

  const [selectedOption, setSelectedOption] = useState<null | string>(null);
  const [otherValue, setOtherValue] = useState<string>('');
  const handleTextareaFocus = () => {
    setSelectedOption('Other (please specify)');
  };

  const handleSubmit = () => {
    if (selectedOption) {
      payload.onSubmit(selectedOption, otherValue);
    }
  };

  const otherOption = options[options.length - 1];
  const submitDisabled = !selectedOption || (selectedOption === otherOption && !otherValue.trim().length);

  return (
    <div className="rounded-lg text-white" style={{ padding: '0 28px 28px' }}>
      <div className="absolute left-0 bottom-0">
        <svg width="680" height="610" viewBox="0 0 680 610" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_8976_44218)">
            <rect width="680" height="610" rx="16" fill="#002730" />
            <g opacity="0.8">
              <circle cx="724.562" cy="643.562" r="115.099" stroke="#64CCC5" strokeWidth="0.582604" />
              <circle opacity="0.8" cx="724.563" cy="643.561" r="153.563" stroke="#64CCC5" strokeWidth="0.582604" />
              <circle opacity="0.7" cx="724.563" cy="643.562" r="192.026" stroke="#64CCC5" strokeWidth="0.582604" />
              <circle opacity="0.6" cx="724.562" cy="643.562" r="230.49" stroke="#64CCC5" strokeWidth="0.582604" />
              <circle opacity="0.5" cx="724.563" cy="643.561" r="268.954" stroke="#64CCC5" strokeWidth="0.582604" />
              <circle opacity="0.4" cx="724.562" cy="643.561" r="307.417" stroke="#64CCC5" strokeWidth="0.582604" />
              <circle opacity="0.3" cx="724.562" cy="643.561" r="345.881" stroke="#64CCC5" strokeWidth="0.582604" />
              <circle opacity="0.2" cx="724.563" cy="643.562" r="384.344" stroke="#64CCC5" strokeWidth="0.582604" />
              <circle opacity="0.15" cx="724.562" cy="643.562" r="422.808" stroke="#64CCC5" strokeWidth="0.582604" />
              <circle opacity="0.1" cx="724.562" cy="643.562" r="461.271" stroke="#64CCC5" strokeWidth="0.582604" />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_8976_44218">
              <rect width="680" height="610" rx="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className="relative">
        <div className="text-3xl font-bold mb-3">Hey, before you go…</div>
        <div className="font-semibold">
          <div>We'd love to hear your feedback to improve FuseBase.</div>
          <div>What made you decide to leave today?</div>
        </div>
        <div className="mt-8 flex flex-col items-start">
          {options.map((option, index) => (
            <div className="mb-3" key={index}>
              <input
                type="radio"
                id={`answer-${index}`}
                name="feedback"
                className="hidden"
                value={option}
                checked={selectedOption === option}
                onChange={() => setSelectedOption(option)}
              />
              <label htmlFor={`answer-${index}`} className="cursor-pointer flex items-center rounded-full">
                <span
                  className={classNames('w-4 h-4 inline-block relative rounded-full border-2 border-neutral-400 mr-2', {
                    'border-teal-500': selectedOption === option,
                  })}
                >
                  {selectedOption === option && (
                    <span
                      className="w-2 h-2 inline-block absolute top-1 left-1 bg-teal-500 rounded-full"
                      style={{ left: '2px', top: '2px' }}
                    ></span>
                  )}
                </span>
                {option}
              </label>
            </div>
          ))}
          <textarea
            className="w-full h-20 rounded-md"
            style={{
              height: '88px',
              backgroundColor: 'rgba(41, 74, 81, 1)',
              padding: '12px',
              resize: 'none',
              border: '1px solid rgba(255, 255, 255, 0.16)',
              outline: 'none',
            }}
            placeholder="Enter your answer"
            onFocus={handleTextareaFocus}
            onChange={(event) => setOtherValue(event.target.value)}
          />
          <div className="mt-8">
            <button
              className={classNames('rounded font-bold', { 'cursor-default': !selectedOption })}
              disabled={submitDisabled}
              style={{
                backgroundColor: submitDisabled ? 'rgba(150, 225, 220, .32)' : 'rgba(150, 225, 220, 1)',
                width: '180px',
                height: '42px',
                color: '#000',
              }}
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
